import { useState } from "react";
import * as Yup from "yup";
import { Formik } from "formik";
import { toast } from "react-toastify";
import InputField from "../../../../atoms/InputField";
import TemplateForm from "../../../../atoms/TemplateForm";
import { UPDATE_EDO_CTA } from "../../../../../api/apiEdoCuenta";

const EditEdoCta = ({ edoCta, refetch, onClose }) => {
    const [ , setArchivo] = useState({ file: null });

    const initialValues = {
        file: null,
    };

    const handleSubmit = async (values, { setSubmitting }) => {
        try {
            await UPDATE_EDO_CTA(edoCta.id, values);
            refetch();
            onClose();
            toast.success("Agregado exitosamente");
        } catch (error) {
            console.error(error);
            toast.error("Error al registrar la factura");
        } finally {
            setSubmitting(false);
        }
    };

    const validationSchema = Yup.object({
        file: Yup.mixed().required("El archivo es requerido"),
    });

    return (
        <Formik initialValues={initialValues} onSubmit={handleSubmit} validationSchema={validationSchema}>
            {({ isSubmitting, setFieldValue }) => (
                <TemplateForm
                    fields={
                        <>
                            <div className="col-span-2">
                                <InputField
                                    name="file"
                                    label="Comprobante de pago"
                                    type="file"
                                    onChange={(e) => {
                                        const file = e.currentTarget.files?.[0] || null;
                                        setFieldValue("file", file);
                                        setArchivo((prev) => ({ ...prev, file: file }));
                                    }}
                                />
                            </div>
                        </>
                    }
                    isSubmitting={isSubmitting}
                    textButton="Aceptar"
                />
            )}
        </Formik>
    );
};

export default EditEdoCta;